import PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';
import { retrieveUriParam } from '../utils/helpers';
import mapperFor from '../views/common/containers/CommonMapper';
import { verifyCodeExists, verifyParams } from './app';
import { checkUserSession } from './auth';

export const paths = {
  LOGIN: '/login',
  NEW_PASSWORD: '/new-password',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_CONFIRM: '/forgot-password-confirm'
};

const routes = [
  {
    component: mapperFor('login')(retrieveUriParam('client_id')),
    exact: true,
    path: paths.LOGIN
  },
  {
    component: mapperFor('new_password')(retrieveUriParam('client_id')),
    exact: true,
    path: paths.NEW_PASSWORD
  },
  {
    component: mapperFor('forgot_password')(retrieveUriParam('client_id')),
    exact: true,
    path: paths.FORGOT_PASSWORD
  },
  {
    component: mapperFor('forgot_password_confirm')(retrieveUriParam('client_id')),
    exact: true,
    path: paths.FORGOT_PASSWORD_CONFIRM
  }
];

const Routes = ({ history }) => (
  <Router history={history}>
    <Switch>
      {routes.map(({ path, ...route }) => <Route key={path} path={path} {...route} />)}
    </Switch>
  </Router>
);

Routes.propTypes = {
  history: PropTypes.objectOf(Object).isRequired
};

export default compose(
  connect(null, dispatch => ({
    onIsNotValidParams: () => dispatch(verifyParams()),
    onCheckUserSession: () => dispatch(checkUserSession()),
    onIsMissingCode: () => dispatch(verifyCodeExists())
  })),
  lifecycle({
    componentDidMount() {
      const { onIsNotValidParams, onIsMissingCode, history } = this.props;
      if (history.location.pathname !== '/forgot-password-confirm') {
        onIsNotValidParams();
      } else {
        onIsMissingCode();
      }
    }
  })
)(Routes);



// WEBPACK FOOTER //
// ./src/core/routes.js